<h2 mat-dialog-title>Pay {{ request.supplier_name }}</h2>

<mat-dialog-content>
  <ol class="steps">
    <li class="step">
      <span class="step-label">1 · {{ accountLabel }} — <bdi>{{ request.payout_method_name || 'unknown method' }}</bdi>@if (request.payout_label) { · <bdi>{{ request.payout_label }}</bdi> }</span>
      <div class="copy-row">
        <span class="card-number" [class.address]="isWallet" dir="ltr">{{ displayAccount || '—' }}</span>
        <button mat-stroked-button type="button" class="copy-btn" [disabled]="!account"
          (click)="copy(account, accountLabel)">
          <mat-icon>content_copy</mat-icon> Copy
        </button>
      </div>
      @if (request.destination_changed) {
      <p class="warn">
        <mat-icon>warning</mat-icon>
        <!-- One flex item: .warn is a row, so bare <bdi>s would each become a column. -->
        <span>The supplier has edited this destination since asking (now <bdi>{{ request.current_payout_account }}</bdi>@if (request.current_payout_holder) { · <bdi>{{ request.current_payout_holder }}</bdi> }).
        This request is paid to the details shown here.</span>
      </p>
      } @else if (request.destination_deleted) {
      <p class="warn">
        <mat-icon>warning</mat-icon>
        The supplier has deleted this destination since asking. This request is still paid to the details shown here.
      </p>
      }
    </li>

    @if (!isWallet) {
    <li class="step">
      <span class="step-label">2 · Check the account holder's name at the bank</span>
      <div class="copy-row">
        <span class="holder">{{ holderName || '—' }}</span>
        <button mat-stroked-button type="button" class="copy-btn" [disabled]="!holderName"
          (click)="copy(holderName, 'Name')">
          <mat-icon>content_copy</mat-icon> Copy
        </button>
      </div>
    </li>
    }

    <li class="step amount-step">
      <span class="step-label">{{ isWallet ? 2 : 3 }} · Amount</span>
      @if (isWallet && request.payout_amount) {
      <div class="copy-row">
        <div>
          <span class="amount-value" dir="ltr">{{ request.payout_amount }} <small>{{ request.payout_currency }}</small></span>
          <span class="amount-rial">
            = {{ request.amount | number }} Toman at {{ +request.payout_rate! | number }} Toman per {{ request.payout_currency }}
            ({{ request.payout_rate_source }}, {{ request.payout_rate_at | date:'short' }})
          </span>
        </div>
        <button mat-stroked-button type="button" class="copy-btn" (click)="copy(request.payout_amount!, 'Amount')">
          <mat-icon>content_copy</mat-icon> Copy
        </button>
      </div>
      } @else {
      <div class="copy-row">
        <div>
          <span class="amount-value">{{ request.amount | number }} <small>Toman</small></span>
          <span class="amount-rial">{{ rial | number }} Rial</span>
        </div>
        <app-copy-rial-button [amount]="request.amount"></app-copy-rial-button>
      </div>
      @if (isWallet) {
      <span class="amount-summary">This request has no fixed coin amount; send the equivalent in {{ request.payout_method_name }}.</span>
      }
      }
      <span class="amount-summary">
        {{ request.runs.length }} transfer run(s) · {{ request.contracts.length }} manual contract(s) — exactly what the supplier asked for
      </span>
    </li>
  </ol>

  <app-payment-source-fields [details]="payment" [disabled]="paying"></app-payment-source-fields>

  <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
    <mat-label>Note</mat-label>
    <input matInput [(ngModel)]="note" maxlength="1000" placeholder="Optional, e.g. bank reference">
  </mat-form-field>

  <div class="file-row">
    <button mat-stroked-button type="button" [disabled]="proofs.length >= room" (click)="fileInput.click()">
      <mat-icon>attach_file</mat-icon> Attach payment proof
    </button>
    <input #fileInput type="file" [accept]="accept" multiple hidden (change)="onFilesSelected($event)">
    <span class="file-count">{{ proofs.length }} / {{ room }}</span>
  </div>
  @if (fileError) { <p class="file-error">{{ fileError }}</p> }
  @if (proofs.length) {
  <div class="previews">
    @for (p of proofs; track p.url; let i = $index) {
    <div class="preview-tile">
      <img [src]="p.url" [alt]="p.file.name">
      <button mat-icon-button type="button" class="remove" matTooltip="Remove" (click)="removeFile(i)">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    }
  </div>
  }

  <mat-checkbox class="confirm" [(ngModel)]="sent" [disabled]="paying">
    @if (isWallet && request.payout_amount) {
    I have sent {{ request.payout_amount }} {{ request.payout_currency }} to this address
    } @else if (isWallet) {
    I have sent the equivalent of {{ request.amount | number }} Toman to this address
    } @else {
    I have sent {{ request.amount | number }} Toman ({{ rial | number }} Rial) to this account
    }
  </mat-checkbox>

  @if (error) { <p class="pay-error"><mat-icon>error</mat-icon> {{ error }}</p> }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" [disabled]="paying" (click)="cancel()">Cancel</button>
  <button mat-flat-button type="button" color="primary" [disabled]="!sent || paying || !payment.source_account_id" (click)="pay()">
    @if (paying) { <mat-spinner diameter="18"></mat-spinner> } @else { <mat-icon>check</mat-icon> }
    Record as paid
  </button>
</mat-dialog-actions>
